import React from "react";
import { STORE_OWNER_ID } from "MODULES/inventories/constants";
import { matchesBoolean, matchesString } from "LIB/filters";
import { Search } from "MODULES/shared/components";
import mroPagination from "MODULES/ManagedRepairOrders/pagination";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { CLEAR_FILTERS_TEXT, NOT_RECEIVED, RECEIVED } from "APP_ROOT/constants";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { properCase } from "LIB/formatters/text";
import useCurrentUser from "../../../hooks/useCurrentUser";
import Table from "./Table";

const defaultFilters = {
  cancelled: undefined,
  received: undefined,
  shipped: undefined,
  store_owner_id: undefined
};

const filters = [
  {
    label: "Not Cancelled",
    filters: {
      cancelled: false
    }
  },
  {
    label: properCase(RECEIVED),
    filters: {
      received: true
    }
  },
  {
    label: properCase(NOT_RECEIVED),
    filters: {
      received: false
    }
  }
];

const filterTags = [
  {
    label: "Show Not Cancelled MROs",
    key: "cancelled",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Received",
    key: "received",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Not Received",
    key: "received",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Invoiced",
    key: "invoiced",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Not Invoiced",
    key: "invoiced",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Shipped",
    key: "shipped"
  }
];

function ManagedRepairOrderSearch({ pushHistory }) {
  const currentUser = useCurrentUser();
  const filterWithLocations = currentUser.locations.map(l => ({
    label: `Managed By ${l.name}`,
    filters: { store_owner_id: l.id }
  }));

  const filterTagsWithLocations = currentUser.locations.map(l => ({
    label: `Managed by ${l.name}`,
    key: STORE_OWNER_ID,
    matchesTarget: matchesString(l.id)
  }));

  return (
    <Search search={mroPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a MRO number, vendor name, vendor number, work order #, part # or part description..."
                submitOnSingleResult={r =>
                  pushHistory(
                    `/managed-repair-orders/${r.managed_repair_order.uuid}`
                  )}
              />
              <FilterSelect
                {...searchProps}
                filters={filters.concat(filterWithLocations).concat({
                  label: CLEAR_FILTERS_TEXT,
                  filters: defaultFilters
                })}
                right
              />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title="Managed Repair Orders"
            filters={filterTagsWithLocations.concat(filterTags)}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

ManagedRepairOrderSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(
  ManagedRepairOrderSearch
);



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Search/ManagedRepairOrderSearch.jsx